module.exports = __webpack_public_path__ + "img/banner1@2x.dce4df0e.png";